export default {"src":"/_next/static/media/siteLogo.c4f9f219.svg","height":53,"width":72,"blurWidth":0,"blurHeight":0};